// Module
var code = "<div class=\"static-color-cell\" ng-if=\"isColor\" ng-style=\"{&#39;background-color&#39;: value}\" tooltip=\"{{value}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"300\"></div><strong ng-if=\"!isColor\">{{value}}</strong>\n";
// Exports
module.exports = code;